module.exports = __webpack_public_path__ + "img/blue-square-table-8.2504c818.png";